<template>
  <div v-html="field.text_html"></div>
</template>
<script>
export default {
  props: {
    field: Object,
  }
}
</script>